<template>
    <div class="modal fade" id="viewPrintAadharAgreementLetter">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printAdharAgreementLetter()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printAdharAgreementLetter">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table printing">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>आधार सहमति पत्र / ऋण करार <br>(Aadhar Agreement Letter / Loan Agreement)</strong></h4></td>
                          <!-- <td class="text-right" width="20%">
                            <div v-if="seeRecord.member_loan_plan">
                              <barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                                Show this if the rendering fails.
                              </barcode>
                            </div>
                          </td> -->
                        </thead>
                      </table>
                      <!-- <hr width="100%" style="height:5px;border-width:0;color:black;background-color:black"> -->
                      <div><p class="text-justify">
                            <big v-if="seeRecord.member_id" class="text-justify"> 
                                मैं श्री <strong>{{ seeRecord.member.name }}</strong> c/o  <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> निवासी <b>{{mem.address}}</b> जिला <b>{{mem.district}}</b> <b v-if="mem.state">राज्य {{mem.state.name}},</b> <b> {{mem.pin}}</b> का मूल निवासी हूँ, 
                                
                              (1) ऋण करार के अनुसार साप्ताहिक पाक्षिक / क़िस्त मूलधन एवं ब्याज सहित घटते हुए क्रम में क़िस्त लिया जायेगा। (2) ब्याज दर और चार्ज में किसी प्रकार का बदलाव होने पर यह अगले ऋण से लागू होगा (3) द्वितीय पक्ष अपने ऋण के भुगतान अपनी स्वेच्छा से अपनी व्यवसाय के अनुसार आवेदन के दौरान साप्ताहिक पाक्षिक मासिक के रूप में कर सकती है जैसा की सदस्य ने चुना है (4) क़िस्त के भुगतान के देरी होने पर किसी भी अतिरिक्त ब्याज पेनल्टी नहीं लिया जायेगा अपनी इच्छानुसार कभी भी पुनर भुगतान कर सकती है (5)सस्था के कर्मचारियों द्वारा ऋण की वसूली के लिए किसी भी अपमान जनक भाषा का उपयोग एवं मोबाइल कॉल सन्देश का उपयोग नहीं करेंगे । (6) सदस्य को कर्मचारियों द्वारा सुबह 9 बजे से पहले एवं सायं 6 बजे के बाद भारतीय रिजर्व बैंक के नियमानुसार अनुमन्य होगा तथा उपयुक्त ऋण करार में वर्णन किये गए नियम को हमने {{getCompanyRecord.companyName}} के कर्मचारी से कंपनी के नियमों एवं शर्तों को स्थानीय भाषा / मातृ भाषा हिंदी में पढ़कर / सुनकर समझ लिया है। (7) कंपनी द्वारा बताई गई सभी शर्तों एवं पक्षों को सहर्ष पूर्वक स्वीकार करता/करती हु और अपने पहचान ही पुष्टि करने हेतु KYC के रूप में आधार कार्ड मतदाता / पहचानपत्र / ड्राविंग लाइसेंस, पैन कार्ड / राशन कार्ड अपनी इच्छा के अनुसार कर्मचारी को सहमति पूर्वक देते हुए उपयुक्त समस्त जानकारी पूर्णतया सत्य दिया गया है सहमति के रूप में हस्ताक्षर करता/करती है। 
                              
                              <!-- <b><span v-if="pl.rateOfInterest">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b>
                              <b>22.7%</b>
                               वार्षिक <span v-if="pl.typeOfInterest === 'reduced'">घटती </span> ब्याज की दर से तुरंत जमा करा दूंगा / दूंगी -->
                            </big>
                            </p>
                            <br><br>
                            <br>
                            <strong>Date: {{seeRecord.disbursementDate | myDate}}</strong>
                      </div><br><br><br><br><br><br><br><br><br><br><br><br><br>
                      <p><table class="table" width="100%">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      p {
        text-align: justify;
      }
      @page {
        size: A4;
        margin: 2;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table, th, td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
    }
  },
  methods: {
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      var fpi = 0
      var gstAmt = 0
      if (pl.fileChargeIncludeAmt === 'true') {
        fpi += this.seeRecord.fileCharge ? this.seeRecord.fileCharge : parseInt(pl.fileCharge)
      }
      if (pl.processingFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.processingFee ? this.seeRecord.processingFee : parseInt(pl.processingFee)
      }
      if (pl.insuranceFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.insuranceFee ? this.seeRecord.insuranceFee : parseInt(pl.insuranceFee)
      }
      if (pl.includeGst === 'true') {
        gstAmt = fpi * 18 / 100
        fpi += parseInt(gstAmt)
      }
      return this.seeRecord.loanAmount ? this.seeRecord.loanAmount + fpi : parseInt(pl.amount) + fpi
      // if (this.seeRecord.loanAmount) {
      //   return this.seeRecord.loanAmount + (pl.fileChargeIncludeAmt === 'true' ? this.seeRecord.fileCharge : 0) + (pl.processingFeeIncludeAmt === 'true' ? this.seeRecord.processingFee : 0)
      // } else {
      //   if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
      //     return parseInt(pl.amount)
      //   } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
      //     return parseInt(pl.amount) + parseInt(pl.processingFee)
      //   } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
      //     return parseInt(pl.amount) + parseInt(pl.fileCharge)
      //   } else {
      //     return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      //   }
      //   // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      // }
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    printAdharAgreementLetter () {
      const d = new Printd()
      d.print(document.getElementById('printAdharAgreementLetter'), [this.cssText])
      // Get HTML to print from element
    //   const prtHtml = document.getElementById('printAdharAgreementLetter').innerHTML

      // Get all stylesheets HTML
    //   let stylesHtml = ''
    //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    //     stylesHtml += node.outerHTML
    //   }
      // Open the print window
    //   const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
    //   WinPrint.document.write(`<!DOCTYPE html>
    //     <html>
    //       <head>
    //         <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
    //           ${stylesHtml}
    //           <style type="text/css">
    //             table th, table td { border:1px solid #000; padding:0.5em; }
    //           </style>
    //       </head>
    //       <body>
    //           ${prtHtml}
    //       </body>
    //     </html>`)

    //   WinPrint.document.close()
    //   WinPrint.focus()
    //   WinPrint.print()
    //   WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    mem: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// AdharAgreementLetter.vue?173235ef